<template>
  <a-space
    direction="vertical"
    :style="{ display: 'flex' }"
  >
    <a-card
      v-for="i in 4"
      :key="i"
    >
      <a-skeleton active />
    </a-card>
  </a-space>
</template>
